module.exports = __webpack_public_path__ + "static/media/push-notification.c234066c.png";